<template>
    <div class="tab-scroll-wrapper">
      <ul class="nav nav-tabs nav-fill nav-justified">
        <li class="nav-item" v-for="(tab, index) in tabs" :key="index">
          <a
            class="nav-link tab-nav-link"
            :class="{
              active: tab.name === activeTab,
              disabled: tab.disabled
            }"
            @click.prevent="!tab.disabled && selectTab(tab.name)"
            :aria-selected="tab.name === activeTab ? 'true' : 'false'"
            :aria-disabled="tab.disabled ? 'true' : 'false'"
          >
            {{ tab.label }}
          </a>
        </li>
      </ul>
    </div>
  </template>
  
  <script>
  export default {
    name: 'NavTabs',
    props: {
      tabs: {
        type: Array,
        required: true
      },
      value: {
        type: String,
        required: true
      }
    },
    computed: {
      activeTab() {
        return this.value;
      }
    },
    methods: {
      selectTab(tabName) {
        this.$emit('input', tabName);
      }
    }
  };
  </script>
  
  <style scoped>
 .nav-link {
  cursor: pointer;
}
.nav-tabs .nav-item {
    margin-bottom: -1px;
}

.nav-justified .nav-item {
    -ms-flex-preferred-size: 0;
    flex-basis: 0;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    text-align: center;
}

.nav-fill .nav-item {
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    text-align: center;
}

.nav-tabs .nav-item {
    margin-bottom: -1px;
}
.nav-tabs {
    border-bottom: 1px solid;
    border-color: white;
}

.nav-tabs.active,.nav-tabs.nav-link.hover {
    border-bottom: 1px solid;
    border-color: white;
}
.tab-nav-link{
   text-decoration: none;
   background-color: transparent;
   font-weight: 500;
   color: #4b5f71;
}

.nav-justified .nav-item {
    -ms-flex-preferred-size: 0;
    flex-basis: 0;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    text-align: center;
}
.nav-tabs .nav-link.tab-nav-link {
  border-bottom: 1px solid #29b289;
}
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link, nav-tabs .nav-link.hover ,.nav-link:focus{
    border-bottom: none !important;
  background-color: rgba(41, 178, 137, 0.1);
  border-color: #29b289 #29b289 #c4c9d0;
  border-bottom: none !important;
  color: #29b289;
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
    border-bottom: none !important;
  border-color: #29b289 #29b289 #c4c9d0;
  border-bottom: none !important;
  color: #29b289;
}
.nav-fill .nav-item {
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    text-align: center;
}

.tab-scroll-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.nav-tabs {
  display: flex;
  flex-wrap: nowrap;
  white-space: nowrap;
  width: max-content;
  min-width: 100%;
}
</style>
  